export function toNumber(string, number = 0) {
  return Number(parseFloat(string || '0').toFixed(number));
}

export function toFixed(value, number = 2) {
  return Number(value).toFixed(number);
}

export function zeroPad(value, length = 2) {
  // Convert floating-point artifacts like 234.14000000000001 -> 234.14
  const normalized = Number.isFinite(value)
    ? parseFloat(value.toFixed(12))
    : value;

  return String(normalized).padStart(length, '0');
}

export  function floatRemainder(val = 0, step = 0) {
  const valCount = (val.toString().split('.')[1] || '').length;
  const stepCount = (step.toString().split('.')[1] || '').length;
  const decCount = valCount > stepCount ? valCount : stepCount;
  const valInt = parseInt(val.toFixed(decCount).replace('.',''), 10);
  const stepInt = parseInt(step.toFixed(decCount).replace('.',''), 10);

  return (valInt % stepInt) / Math.pow(10, decCount);
}

export function getAverage(arr = []) {
  if (arr.length === 0) {
    return 0;
  }
  const sum = arr.reduce((acc, val) => acc + val, 0);
  return sum / arr.length;
}
